import React, { useEffect, useState } from "react";

export interface IExperienceValues {
  min: string;
  max: string;
}

interface IProps {
  onSelect?: (value: string, type: "min" | "max") => void;
  selectedExp: IExperienceValues
}

const ExperienceDropdown: React.FC<IProps> = ({ onSelect, selectedExp }) => {
  const years: string[] = Array.from({ length: 51 }, (_, i) =>
    i === 0 ? "0 yr" : i === 1 ? "1 yr" : `${i} yrs`
  );
  const [minExp, setMinExp] = useState<string>("");
  const [maxExp, setMaxExp] = useState<string>("");

  const handleSelectMin = (val: string) => {
    setMinExp(val);
    if (onSelect) onSelect(val, "min");
  };

  const handleSelectMax = (val: string) => {
    setMaxExp(val);
    if (onSelect) onSelect(val, "max");
  };

  useEffect(() => {
    setMinExp(selectedExp.min);
    setMaxExp(selectedExp.max);
  }, [selectedExp]);

  return (
    <div className="qs_exp_dd_container">
      <div className="qs_exp_dd_col">
        <div>Minimum</div>
        <ul className="qs_exp_dd_col_list">
          {(maxExp === ""
            ? years
            : years.filter((yr) => Number(yr.split(" ")[0]) <= Number(maxExp.split(" ")[0]))
          ).map((yr) => (
            <li
              key={`min-${yr}`}
              className={`qs_exp_dd_col_list_item qs_pointer ${
                minExp === yr ? "active" : ""
              }`}
              onClick={() => handleSelectMin(yr)}
            >
              {yr}
            </li>
          ))}
        </ul>
      </div>

      <div className="qs_exp_dd_divider" />

      <div className="qs_exp_dd_col">
        <div>Maximum</div>
        <ul className="qs_exp_dd_col_list">
          {(minExp === ""
            ? years
            : years.filter((yr) => Number(yr.split(" ")?.[0]) >= Number(minExp.split(" ")?.[0]))
          ).map((yr) => (
            <li
              key={`max-${yr}`}
              className={`qs_exp_dd_col_list_item qs_pointer ${
                maxExp === yr ? "active" : ""
              }`}
              onClick={() => handleSelectMax(yr)}
            >
              {yr}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default React.memo(ExperienceDropdown);
